import UnderlinedText from "./underlined_text";
import { Grid, Typography } from "@mui/material";
import { fieldHeader } from "../../../../components/fields/field_header";

const ViewCorporationInformation = ({ data }: any) => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          CORPORATION INFORMATION:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Legal Corporate Name", false)}</Grid>
        <UnderlinedText text={data.legalCorpName} />
      </Grid>
      <Grid item xs={12}>
        <Grid item>
          {fieldHeader(
            "Corporation Address (if different from store address)",
            false
          )}
        </Grid>
        <UnderlinedText text={data.corpAddress} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Corporation City", false)}</Grid>
        <UnderlinedText text={data.corpCity} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Corporation State", false)}</Grid>
        <UnderlinedText text={data.corpState} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Corporation ZIP", false)}</Grid>
        <UnderlinedText text={data.corpZip} />
      </Grid>
    </>
  );
};

export default ViewCorporationInformation;
